module.exports = __webpack_public_path__ + "static/supporters_center_img1@2x-5a233987455abba12e5279e415745548.jpg";